module.exports = __webpack_public_path__ + "img/921347.4c0876ab.png";